export default "__VITE_ASSET__DCCoPxFG__"